/* Beauté Fashion Europe — interactions légères, sans dépendance */
(function () {
  'use strict';

  /* ----- Boutons de quantité (+ / −) ----- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.quantity');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 0;
    var value = (parseInt(input.value, 10) || 0) + step;
    if (value < min) value = min;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----- Mise à jour automatique du panier ----- */
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    var cartTimer;
    cartForm.addEventListener('change', function (event) {
      if (!event.target.matches('[data-cart-qty]')) return;
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () { cartForm.submit(); }, 400);
    });
  }

  /* ----- Galerie produit : miniatures ----- */
  var mainImage = document.getElementById('MainProductImage');
  if (mainImage) {
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        mainImage.removeAttribute('srcset');
        mainImage.src = full;
        document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ----- Changement de variante : prix, dispo, image ----- */
  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;

      var available = option.getAttribute('data-available') === 'true';
      var price = option.getAttribute('data-price') || '';
      var compare = option.getAttribute('data-compare');
      var image = option.getAttribute('data-image');

      var priceBox = document.getElementById('ProductPrice');
      if (priceBox) {
        if (compare) {
          priceBox.innerHTML =
            '<span class="price price--sale"><span class="price__sale">' + price +
            '</span> <s class="price__compare">' + compare + '</s></span>';
        } else {
          priceBox.innerHTML = '<span class="price"><span class="price__regular">' + price + '</span></span>';
        }
      }

      var addButton = document.getElementById('AddToCart');
      if (addButton) {
        addButton.disabled = !available;
        var label = addButton.querySelector('[data-add-label]');
        if (label) label.textContent = available ? 'Ajouter au panier' : 'Épuisé';
      }

      if (image && mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.src = image;
      }
    });
  }

  /* ----- Fermer les menus <details> en cliquant ailleurs ----- */
  document.addEventListener('click', function (event) {
    document.querySelectorAll('details.header-search[open], details.menu-drawer[open]').forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  /* ----- Échap ferme les panneaux ouverts ----- */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.header-search[open], details.menu-drawer[open]').forEach(function (details) {
      details.removeAttribute('open');
    });
  });
})();
